import { useMemo } from "react";
import LineChart from "components/Dashboard/LineChart";
import TodayInformation from "components/Dashboard/TodayInformation";
import PaymentType from "components/Dashboard/PaymentType";
import Resume from "components/Dashboard/Resume";
import TopProducts from "components/Dashboard/TopProducts";
import CompanyName from "components/Dashboard/CompanyName";
import { useOrderHourly } from "graphql/useOrders";
import { useOrderItemSummary } from "graphql/useOrderItemSummary";
import {
  useOrderPaymentSummary,
  useOrderSummary,
  useOrderUserSummary,
} from "graphql/useOrderSummary";
import useBusiness from "graphql/useBusiness";
import { useCustomerSummary } from "graphql/useCustomerSummary";
import {
  filterSortMapSellsByHourSameDay,
  cleanTodaySells,
} from "helpers/dataHelper";
import { useBusinessContext } from "BusinessApp";
import s from "./styles";
import { useDatesContext } from "../../context/DatesContext";

function Dashboard() {
  const { storeId } = useBusinessContext();

  const { month, day } = useDatesContext();

  const { orderSummary: orderSummary30Days, loading: loading1 } =
    useOrderSummary({
      storeId,
      start: month.start,
      end: month.end,
    });

  const { orderSummary: orderSummary30DaysCre, loading: loading12 } =
    useOrderSummary({
      storeId,
      start: month.start,
      end: month.end,
      type: "cre",
    });

  const { orderSummary: orderSummaryToday, loading: loading2 } =
    useOrderSummary({
      storeId,
      start: day.start,
      end: day.end,
    });

  const { orderSummary: orderSummaryTodayCre, loading: loading11 } =
    useOrderSummary({
      storeId,
      start: day.start,
      end: day.end,
      type: "cre",
      month,
    });

  const { orderPaymentSummary, loading: loading3 } = useOrderPaymentSummary({
    storeId,
    type: "fac",
    start: month.start,
    end: month.end,
  });

  const { orderPaymentSummary: orderPaymentSummaryCre, loading: loading13 } =
    useOrderPaymentSummary({
      storeId,
      type: "cre",
      start: month.start,
      end: month.end,
    });

  const paymentType = useMemo(() => {
    const refund_cash = orderPaymentSummaryCre.find(
      (order) => order._id.code === "refund_cash"
    );
    const refund_card = orderPaymentSummaryCre.find(
      (order) => order._id.code === "refund_card"
    );
    const refund_other = orderPaymentSummaryCre.find(
      (order) => order._id.code === "refund_other"
    );

    const paymentType = [];
    orderPaymentSummary.forEach((element) => {
      if (element._id.code === "cash") {
        paymentType.push({
          name: "cash",
          count: element.count,
          total: element.total - (refund_cash?.total || 0),
        });
      } else if (element._id.code === "card") {
        paymentType.push({
          name: "card",
          count: element.count,
          total: element.total - (refund_card?.total || 0),
        });
      } else {
        paymentType.push({
          name: "others",
          count: element.count,
          total: element.total - (refund_other?.total || 0),
        });
      }
    });
    return paymentType;
  }, [orderPaymentSummary, orderPaymentSummaryCre]);

  const { orderItemSummary, loading: loading4 } = useOrderItemSummary({
    storeId,
    start: day.start,
    end: day.end,
    limit: 3,
    order: -1,
    sort: "quantity",
    // type: null,
    withCustomer: true,
  });

  const { orderItemSummary: orderItemSummaryCre, loading: loading14 } =
    useOrderItemSummary({
      storeId,
      start: day.start,
      end: day.end,
      limit: 3,
      order: -1,
      sort: "quantity",
      type: "cre",
      withCustomer: true,
    });

  const { orderItemSummary: monthMostSoldItem, loading: loading5 } =
    useOrderItemSummary({
      storeId,
      start: month.start,
      end: month.end,
      limit: 5,
      sort: "quantity",
    });

  const orderItemSummaryMapped =
    (orderItemSummary &&
      orderItemSummary
        .filter((item) => item._id && item._id.itemId)
        .map((item) => {
          const itemCre = orderItemSummaryCre.find(
            (itemCre) => itemCre._id.itemId === item._id.itemId
          );

          const units = item?.quantity + (itemCre?.quantity || 0);
          const total = units * Math.abs(item?._id.unitPrice || 0);

          return {
            total: total,
            units,
            name: item._id && item._id.itemName,
            subCategory: item._id && item._id.subcategoryName,
          };
        })
        .sort((a, b) => b.total - a.total)) ||
    [];

  const { business, loading: loading6 } = useBusiness();

  const { orderHourlySummary: todayOrderHourlySummary, loading: loading7 } =
    useOrderHourly(storeId, day.start, day.end);
  const sortedDayByHourSells = cleanTodaySells(
    filterSortMapSellsByHourSameDay(todayOrderHourlySummary)
  );

  const { orderUserSummary: bestWorker30days, loading: loading8 } =
    useOrderUserSummary({
      storeId,
      start: month.start,
      end: month.end,
      top: 1,
      sort: "total",
    });

  const { customerSummary: newClients30Days, loading: loading9 } =
    useCustomerSummary(storeId, month.start, month.end);

  const { customerSummary: newClientsToday, loading: loading10 } =
    useCustomerSummary(storeId, day.start, day.end);

  const loading =
    loading1 ||
    loading2 ||
    loading3 ||
    loading4 ||
    loading5 ||
    loading6 ||
    loading7 ||
    loading8 ||
    loading9 ||
    loading10 ||
    loading11 ||
    loading12 ||
    loading13 ||
    loading14;

  return (
    <div>
      <s.PageContainer>
        <s.LeftContainer>
          <TodayInformation
            sells={orderSummaryToday && orderSummaryToday.count}
            earnings={
              parseInt(orderSummaryToday.total || 0) -
              parseInt(orderSummaryTodayCre.total || 0)
            }
            mostSelling={orderItemSummary && orderItemSummary[0]?._id?.itemName}
            newClients={newClientsToday && newClientsToday.count}
          />
          <LineChart list={sortedDayByHourSells} loading={loading} />
          <TopProducts items={orderItemSummaryMapped} loading={loading} />
        </s.LeftContainer>
        <s.RightContainer>
          <s.WrapperResponsive>
            <CompanyName companyName={business.name} />
          </s.WrapperResponsive>
          <>
            <Resume
              totalSales={orderSummary30Days && orderSummary30Days.count}
              totalGains={
                parseInt(orderSummary30Days.total || 0) -
                parseInt(orderSummary30DaysCre.total || 0)
              }
              soldItems={
                parseInt(orderSummary30Days.quantity || 0) -
                parseInt(orderSummary30DaysCre.quantity || 0)
              }
              mostSoldItem={monthMostSoldItem[0]?._id?.itemName}
              monthWorker={bestWorker30days && bestWorker30days[0]?._id?.user}
              newClients={newClients30Days && newClients30Days.count}
              loading={loading}
            />
          </>
          <PaymentType paymentType={paymentType} loading={loading} />
        </s.RightContainer>
      </s.PageContainer>
    </div>
  );
}

export default Dashboard;
